import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Dropdown } from '@bibliocommons/deprecated-base-dropdown';
import { Cog } from '@bibliocommons/deprecated-base-icons';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import './GroupingSummary.scss';

export default class GroupingSummary extends React.PureComponent {
  static renderOption(value, key) {
    return (
      <li key={key} className="menu-item" style={{ color: value ? 'green' : 'lightgrey' }}>
        <strong>{key}</strong>: {value}
      </li>
    );
  }

  static renderDefaultSelected() {
    return (
      <span>
        <Cog />
        <ScreenReaderMessage>
          <FormattedMessage id="debug_grouping_summary" />
        </ScreenReaderMessage>
      </span>
    );
  }

  render() {
    const { groupSummary } = this.props;
    return (
      <div className="cp-grouping-summary">
        <Dropdown
          dataKey="grouping-summary-dropdown"
          selected={GroupingSummary.renderDefaultSelected()}
          handleSelect={() => {}}
          className="btn-link"
          right
        >
          {groupSummary && groupSummary.map(GroupingSummary.renderOption).toArray()}
        </Dropdown>
      </div>
    );
  }
}

GroupingSummary.propTypes = {
  groupSummary: ImmutablePropTypes.map
};
